import { FilterConfig } from 'App/babel/filterConfigs/FilterConfig';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import { FilterPreset, generateFilter } from '../filterGenerators';
import AppService from 'App/legacy/AppService';

const productFilterConfigs = (): { [key: string]: FilterConfig } => {
	const hasProductDescription = isAvailable(Feature.PRODUCT_DESCRIPTION);
	const configs: { [key: string]: FilterConfig } = {
		// Article number — gated by NEW_FIELDS soft-deploy + standardFields.Product.ArticleNo.active,
		// which the filter drawer enforces automatically via `unreleasedFeature: 'NEW_FIELDS'`.
		ArticleNo: generateFilter(FilterPreset.Text, {
			field: 'articleNo',
			title: 'product.articleNo',
			unreleasedFeature: 'NEW_FIELDS'
		}),
		ProductCategory: generateFilter(FilterPreset.List, {
			field: 'category.id',
			title: 'default.category',
			inputType: 'select',
			dataPromise: () =>
				Promise.resolve({
					data: AppService.getProductCategories()
				})
		}),
		Price: generateFilter(FilterPreset.Range, {
			field: 'listPrice',
			title: 'default.price'
		})
	};

	// Description matches the EditProduct gate: PRODUCT_DESCRIPTION feature +
	// standardFields.Product.Description.active — no NEW_FIELDS, unlike articleNo
	if (hasProductDescription && AppService.getMetadata().standardFields.Product.Description?.active) {
		configs.Description = generateFilter(FilterPreset.Text, {
			field: 'description',
			title: 'default.description'
		});
	}

	return configs;
};

export default productFilterConfigs;
